<div class="user-board-container">
  <div class="left-blocks">
    <div class="inventory-block board-block">
      <div class="header">
        <div class="text-title-1">
          Good {{getTimeOfDay()}}, {{(user$ | async)?.firstName}}
        </div>
        <div *ngIf="showInventoryControls === true" class="description">
          What would you like to do today?
        </div>

        <div *ngIf="showInventoryControls === false" class="description">
          You’ll need to add inventory to use C2 Keep. <br>
          <a class="inventory-link" routerLink="./../inventory/bulk-add">Let’s do that now</a>
        </div>
      </div>

      <div *ngIf="showInventoryControls === true" class="block-controls">
        <app-button customClasses="px-5"
                    [minWidth]="0"
                    class="dispense-btn"
                    [text]="'Dispense'"
                    (clicked)="dispense()"
        ></app-button>

        <app-button class="inventory-menu"
                    customClasses="px-5"
                    [minWidth]="0"
                    [icon]="'icon-three-dots'"
                    subStyle="white"
                    [text]="'More'"
                    appMenu
                    [placement]="'bottom-right'"
                    [autoClose]="'outside'"
                    [menuContent]="inventoryMenuContent"
                    triggers="manual"
                    #inventoryMenu="appMenu"
                    (clicked)="inventoryMenu.toggle()"
                    [hasAnimation]="true"
        ></app-button>

        <ng-template #inventoryMenuContent>
          <div class="menu-container primary">
            <div (click)="receiveInventory();inventoryMenu.close()" class="menu-item">
              <div class="option">
                Receive Inventory
              </div>
            </div>
            <div (click)="reportLostOrStolen();inventoryMenu.close()" class="menu-item">
              <div class="option">
                Report Lost or Stolen
              </div>
            </div>
            <div (click)="medsDamagedOrExpired();inventoryMenu.close()" class="menu-item">
              <div class="option">
                Meds Damaged or Expired
              </div>
            </div>

            <div *ngIf="inventoryLocationsEnabled$ | async"
              (click)="showMoveInventoryDialog = true;inventoryMenu.close()" 
              class="menu-item">
              <div class="option">
                Move Inventory
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <div *ngIf="showStatisticsBlock" class="statistics-block board-block">
      <div class="statistics-block-header">
        <div class="header">
          Overview
        </div>
        <app-dropdown [options]="[]" [placeholder]="'Select Period'"></app-dropdown>
      </div>
      <div class="statistics-count-container">
        <div class="all-transactions-count">
          <div class="count-header">All Transactions</div>
          <div class="count-number">1.1k</div>
          <div class="count-accretion">+12.2%</div>
        </div>
        <div class="my-transactions-count">
          <div class="count-header">My Transactions</div>
          <div class="count-number">248</div>
          <div class="count-accretion">-1.5%</div>
        </div>
        <div class="all-transactions-count">
          <div class="count-header">Amendments</div>
          <div class="count-number">65</div>
          <div class="count-accretion">+24.9%</div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="(profileLoading$ | async) !== true && showSetupBlock"
       class="setup-block board-block"
  >
    <div class="setup-block-header">
      You’re almost set up!
    </div>

<!--    <a (click)="goToPage('reports', !setupProgress.hasOrder)"-->
<!--       [ngClass]="{'animation-focus-default': !setupProgress.hasOrder,-->
<!--       disabled: setupProgress.hasOrder}"-->
<!--       class="setup-block-step"-->
<!--    >-->
<!--      <span class="text">Order integration</span>-->
<!--    </a>-->
    <a (click)="goToPage('inventory/bulk-add', !setupProgress.hasInventory)"
       [ngClass]="{'animation-focus-default': !setupProgress.hasInventory,
       disabled: setupProgress.hasInventory}"
       class="setup-block-step"
    >
      <span class="text">Add your inventory</span>
    </a>
    <a *ngIf="adminRoles.includes((currentPharmacy$ | async)?.role)"
       (click)="goToPage('team', !setupProgress.hasTeammates)"
       [ngClass]="{'animation-focus-default': !setupProgress.hasTeammates,
       disabled: setupProgress.hasTeammates}"
       class="setup-block-step"
    >
      <span class="text">Add teammates</span>
    </a>

<!--    <a (click)="delaySetup()" class="setup-delay-ref animation-focus-default">-->
<!--      Remind me in a week-->
<!--    </a>-->
  </div>
</div>

<!-- DIALOGS ACTIONS MISC -->
<app-multiple-drugs-dialog-base *ngIf="showDispenseDialog"
  header="Dispensing" 
  (cancel)="showDispenseDialog = false"
  (save)="dispenseDrug($event)"
  drugScannerLabel="Which drug are you dispensing?"
  submitBtnText="Dispense"
  [activityType]="ActivityTypesEnum.Dispensed"
></app-multiple-drugs-dialog-base>

<app-receive-dialog *ngIf="showReceiveDialog"
  (cancel)="showReceiveDialog = false"
  (save)="receiveDrug($event)"
></app-receive-dialog>

<app-multiple-drugs-dialog-base *ngIf="showRecordLostDialog"
  header="Recording Lost or Stolen"
  [dialogType]="DialogTypeEnum.RecordLostOrStolen" 
  (cancel)="showRecordLostDialog = false"
  (save)="recordLostOrStolenDrug($event)"
  drugScannerLabel="Which drug are you reporting lost or stolen?"
  submitBtnText="Record Lost/Stolen"
  [activityType]="ActivityTypesEnum.LostStolen"
></app-multiple-drugs-dialog-base>

<app-multiple-drugs-dialog-base *ngIf="showDamagedOrExpiredDialog"
  header="Recording Damaged or Expired"
  [dialogType]="DialogTypeEnum.RecordDamagedOrExpired" 
  [show]="showDamagedOrExpiredDialog"
  [hideHeaderUnderline]="true"
  (cancel)="showDamagedOrExpiredDialog = false"
  (save)="recordDamagedOrExpiredDrug($event)"
  drugScannerLabel="Which drug are you reporting damaged or expired?"
  [activityType]="ActivityTypesEnum.DamagedExpired"
  submitBtnText="Record Damaged/Expired"
>
<div class="sub-header-container flex flex-col" subHeader *ngIf="inventoryLocationsEnabled$ | async">
  <div class="flex">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none" class="mt-1">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.08264 1.40854C7.92371 -0.0866987 10.0765 -0.0866995 10.9176 1.40853L17.0559 12.3211C17.8808 13.7877 16.8211 15.5997 15.1384 15.5997H2.86177C1.17915 15.5997 0.119383 13.7877 0.944306 12.3211L7.08264 1.40854ZM10.1 12.2998C10.1 12.9073 9.60753 13.3998 9.00001 13.3998C8.3925 13.3998 7.90001 12.9073 7.90001 12.2998C7.90001 11.6923 8.3925 11.1998 9.00001 11.1998C9.60753 11.1998 10.1 11.6923 10.1 12.2998ZM9.00001 3.49983C8.3925 3.49983 7.90001 3.99232 7.90001 4.59983V7.89983C7.90001 8.50734 8.3925 8.99983 9.00001 8.99983C9.60752 8.99983 10.1 8.50734 10.1 7.89983V4.59983C10.1 3.99232 9.60752 3.49983 9.00001 3.49983Z" fill="#F87171"/>
    </svg> 
    <div class="sub-header">The drug & quantity will be automatically transferred to the Damage/Expired inventory location.</div>
  </div>
 
  <div class="mb-2"></div>
</div>
</app-multiple-drugs-dialog-base>

<app-move-inventory-dialog *ngIf="showMoveInventoryDialog"
  (successfullySaved)="notifyMoveOperationResult(true)"
  (failed)="notifyMoveOperationResult(false)"
  (cancel)="showMoveInventoryDialog = false"
></app-move-inventory-dialog>

<app-enter-pin-dialog [show]="showPinDialog"
                      (cancel)="closePinDialog()"
                      [focusPin]="focusPin"
                      (setPinHandler)="afterPinHandled($event)"
                      (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-reset-pin-dialog [show]="showResetPinDialog"
                      (cancel)="closeResetPinDialog()"
                      (afterUpdate)="afterPinUpdated($event)"
></app-reset-pin-dialog>

<app-dialog [show]="showSetPinDialog" [showHeader]="false" [minWidthDefault]="false">
  <app-set-pin-dialog
    [isInvited]="true"
    [displayToggle]="true"
    (cancel)="closeSetPinDialog()"
    (afterPinSet)="closeSetPinDialog()"
    *ngIf="showSetPinDialog"
  ></app-set-pin-dialog>
</app-dialog>
